module.exports = __webpack_public_path__ + "static/main3_pc-5b7c619cf813f59ae8ccd2811ed0ae4b.jpg";